<template>
    <div class="step">
        <div class="step__container">

            <div class="step__welcome" ref="welcome">
                <p>Welcome to the family!</p>
            </div>

            <div class="step__title" ref="title">
                <p>Click the Download button below or search for us on the App Store. Log in with your account.</p>
            </div>

            <div class="step__subtitle" ref="subtitle">
                <p>If you need any help at all just email us at help@ohanaisfamily.com or call us at (240) 543-2074</p>
            </div>

            <a href="https://ohanaisfamily.com/download">
              <downloadButton style="width: 15em; display: block; margin-left: auto; margin-right: auto; margin-top: 4em;"></downloadButton>
            </a>

            <div class="step__button">
                <button @click="goNextStep" class="button" ref="button">
                    <span>Back to home</span>
                </button>
            </div>

        </div>
    </div>
</template>

<script>

    import { TimelineMax } from 'gsap';
    
    import downloadButton from '@/assets/svg/app_store_download_button.svg';

    let tl = new TimelineMax({
        delay: 1
    });

    export default {
        name: 'Step8_Welcome',
        methods: {
            goNextStep() {
                // This needs to route to the Ohana index
                window.location.href = 'https://ohanaisfamily.com/';
            }
        },
        components: {
            downloadButton
        },
        mounted() {

            amplitude.getInstance().logEvent('signup_page_final_loaded');

            const {title, welcome, subtitle, button} = this.$refs;
            tl
            .from([title, welcome, subtitle], 1.2, {autoAlpha: 0, ease: Power2.easeOut})
            .from(button, 1.2, {scale: .9, autoAlpha: 0, ease: Power2.easeOut}, "-=.8")
        }
    }
</script>




// WEBPACK FOOTER //
// Step8_Welcome.vue?560cd648